import routerHelper from '../../common/routerHelper'

export default { ...routerHelper }
